export default __webpack_public_path__ + "static/media/ban-mobile-image-9.f84a2f96.jpg";